module.exports = __webpack_public_path__ + "img/clone_icon.43bfa756.svg";